export default {
    type: 'citations',
    aliases: {
        camel: 'citations',
        singular: 'Citation',
        plural: 'Citations',
        lowerSingular: 'citation',
        lowerPlural: 'citations',
    },
    relations: {
        'people': {
            adminLabel: "Authors",
            pivot: {
                type: 'person-citations',
                localKey: 'citationId',
                foreignKey: 'personId'
            }
        },
        'specialisations': {
            adminLabel: "Specialisations",
            pivot: {
                type: 'citation-specialisations',
                localKey: 'citationId',
                foreignKey: 'specialisationId'
            }
        },
    },
    publishable: true,
    adminSection: 'research',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerCitationRecord',
            loader: () => import('./AdministerCitationRecord')
        },
        adminRelations: {
            name: 'AdministerRelations',
            loader: () => import('@/services/resources/ui/AdministerRelations')
        },
        webCollectionItem: {
            name: 'CitationPoster',
            loader: () => import('./CitationPoster')
        },
        webCollectionItemAlt: {
            name: 'CitationPosterSimple',
            loader: () => import('./CitationPosterSimple')
        }
    },
};
